// extracted by mini-css-extract-plugin
export default {"section":"imageUploader_section__jIzp3","image":"imageUploader_image__-ILuk","minWidth":"imageUploader_minWidth__L40OE","minWidth1":"imageUploader_minWidth1__xcGj+"};